import { Heart } from "lucide-react";
import Logo from "./Logo";

const NAV = [
    { href: "#sobre", label: "Sobre" },
    { href: "#servicos", label: "Serviços" },
    { href: "#livro", label: "Livro" },
    { href: "#faq", label: "Dúvidas" },
    { href: "#contato", label: "Contato" },
];

const Footer = ({ base = "" }) => (
    <footer className="border-t border-lav bg-white/70 backdrop-blur-sm" data-testid="footer">
        <div className="mx-auto max-w-7xl px-5 pt-14 sm:px-8">
            <div className="grid gap-10 pb-12 text-center sm:grid-cols-2 sm:text-left">
                <div className="flex flex-col items-center sm:items-start">
                    <a href={`${base}#inicio`} className="flex items-center gap-3" data-testid="footer-logo-link">
                        <Logo size={52} />
                        <span className="leading-tight">
                            <span className="block font-serif text-xl font-bold text-plum">Maricleia Araújo</span>
                            <span className="block text-[11px] uppercase tracking-[0.22em] text-serenity">Gerontóloga</span>
                        </span>
                    </a>
                    <p className="mt-4 font-serif text-base italic text-serenity">“Cuidado que transforma vidas.”</p>
                    <p className="mt-4 max-w-xs text-xs leading-relaxed text-ink/60">
                        Gerontóloga em Curitiba · Terapia Ocupacional para idosos · Saúde Mental do Idoso · Atendimento domiciliar em Curitiba e região
                    </p>
                </div>

                <nav className="flex flex-col items-center gap-3 sm:items-end" aria-label="Links do rodapé">
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-serenity">Navegação</p>
                    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 sm:flex-col sm:items-end sm:gap-y-3">
                        {NAV.map((l) => (
                            <a key={l.href} href={`${base}${l.href}`} data-testid={`footer-link-${l.label.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`} className="text-base font-medium text-ink transition-colors hover:text-plum">
                                {l.label}
                            </a>
                        ))}
                    </div>
                </nav>
            </div>
        </div>

        <div className="border-t border-lav/70">
            <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-5 pb-28 pt-6 text-center text-xs text-ink/50 sm:flex-row sm:px-8 sm:pb-6 sm:text-left">
                <p data-testid="footer-copyright">© {new Date().getFullYear()} Maricleia Araújo — Todos os direitos reservados.</p>
                <a href="/privacidade" data-testid="footer-privacy-link" className="underline-offset-2 transition-colors duration-300 hover:text-plum hover:underline">
                    Política de Privacidade
                </a>
                <a
                    href="https://www.opaatec.com.br"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-credits-link"
                    className="inline-flex items-center gap-1 transition-colors duration-300 hover:text-plum"
                >
                    Desenvolvido com carinho
                    <Heart size={11} className="text-lilac" fill="currentColor" />
                    por oPaaTec
                </a>
            </div>
        </div>
    </footer>
);

export default Footer;
